export const mockGames = [
  {
    id: 1,
    image: "https://th.bing.com/th/id/OIP.JzCMdekRg2JWrYo_nziUgwAAAA?pid=ImgDet&rs=1",
    platform: "PC",
    title: "Minecraft",
    description: "Build and explore your own virtual world.",
    createDate: "2023-05-01",
    modifyDate: "2023-05-10",
  },
  {
    id: 2,
    image: "https://th.bing.com/th/id/R.009a792192dedd6cb2e952313dd01239?rik=DadAj1L7k1exMw&pid=ImgRaw&r=0",
    platform: "Other",
    title: "Assassin's Creed",
    description: "Experience the epic adventures of assassins in different historical settings.",
    createDate: "2023-05-02",
    modifyDate: "2023-05-11",
  },
  {
    id: 3,
    image: "https://th.bing.com/th/id/R.7786fbdb5c5ef3caf15c70c29e7965de?rik=WFIK3giLYrXRTA&pid=ImgRaw&r=0",
    platform: "Nintendo",
    title: "Pokemon Legends: Arceus",
    description: "Embark on a new Pokemon adventure in the vast and wild Hisui region.",
    createDate: "2023-05-03",
    modifyDate: "2023-05-12",
  },
  {
    id: 4,
    image: "https://th.bing.com/th/id/OIP.fcebKTHJLmLhN3dq3hQDKAAAAA?pid=ImgDet&rs=1",
    platform: "VR",
    title: "Beat Saber",
    description: "Slice through blocks and experience the rhythm of the music in this VR game.",
    createDate: "2023-05-04",
    modifyDate: "2023-05-13",
  },
  {
    id: 5,
    image: "https://th.bing.com/th/id/OIP.-ygnmbpe7bgfCItXfEsIIgHaE8?pid=ImgDet&rs=1",
    platform: "Other",
    title: "Super Mario Odyssey",
    description: "Join Mario on a 3D platforming adventure to rescue Princess Peach from Bowser.",
    createDate: "2023-05-05",
    modifyDate: "2023-05-14",
  },
];
